<template>
  <v-snackbar v-model="showinfomsg" timeout="3000"><div :class="`infomsgarea`">{{ infomsg }}</div></v-snackbar>
  <v-snackbar v-model="showerrmsg" timeout="3000"><div :class="`errmsgarea`">{{ errmsg }}</div></v-snackbar>
  <div :class="`status-bar`">
    <div :class="`lynx-server-status`">
      <v-icon icon="mdi-cloud" :class="`status_${ serverstatus }`"/>&nbsp;
    </div>
    <div>
      <span :class="`user-infos`"><template v-if="authinfos!=null">{{ authinfos }}@</template>{{ constants.api_env }} v{{ constants.version }}</span>
    </div>
    <div :class="`invivoo_text`">© Invivoo</div>
  </div>
</template>

<script>
import { StatusStore, LastErrorStore, LastInfoStore, AuthStore } from '@/stores'
import constants from '@/constants'

export default {
  data: () => ({
    showerrmsg: false,
    showinfomsg: false,
    constants: constants
  }),
  computed: {
    errmsg: function () {
      return LastErrorStore().LastError
    },
    errlistener: function () {
      return LastErrorStore().ErrorListener
    },

    infomsg: function () {
      return LastInfoStore().LastInfo
    },
    infolistener: function () {
      return LastInfoStore().InfoListener
    },

    serverstatus: function () {
      return StatusStore().ServerStatus
    },
    authinfos: function () {
      if (AuthStore() && AuthStore().AuthInfos) {
        return AuthStore().AuthInfos.user.login
      } else {
        return null
      }
    }
  },

  watch: {
    errlistener: function (newval, oldval) {
      if (LastErrorStore().HasError) {
        this.showerrmsg = true
      }
    },
    infolistener: function (newval, oldval) {
      if (LastInfoStore().HasInfo) {
        this.showinfomsg = true && this.showerrmsg === false
      }
    }
  }
}
</script>

<style>
.status-bar {
    font-family:Verdana, Geneva, Tahoma, sans-serif;
    font-size: 80%;
    padding: 2px;
    color: black;
    position: fixed;
    bottom: 0; /* Alignement au bas de la fenêtre */
    left: 0; /* Alignement à gauche de la fenêtre */
    width: 100%; /* S'étend sur toute la largeur */
    box-shadow: inset 0 0 2px #000000; /* Effet d'ombrage intérieur */
    background-color: rgb(196, 196, 196);
}
.lynx-server-status {
  float: inline-start;
  margin-left: 1%;
  vertical-align: baseline;
}
.invivoo_text {
  float: inline-end;
  margin-right: 1%;
  vertical-align: baseline;
}
.user-infos {
  float: inline-start;
}
.user-infos>span, .lynx-server-status>span  {
  margin-left: 5px;
  vertical-align: middle;
}
.usericontyle {
  color: blue;
}
.status_true {
    color: green;
}
@keyframes vibration {
  0% { transform: translateX(0); }
  25% { transform: translateX(-2px); }
  50% { transform: translateX(2px); }
  75% { transform: translateX(-2px); }
  100% { transform: translateX(0); }
}
.status_false {
    color: red;
    animation: vibration 0.5s infinite; /* Appliquez l'animation ici */
}
.errmsgarea {
  color: rgb(255, 160, 160);
  width: 100%;
  text-align: center;
}
.infomsgarea {
  color: rgb(0, 130, 195);
  width: 100%;
  text-align: center;
}
</style>
